const loaded = new Set<string>();

export function preloadImages(urls: string[]): Promise<void> {
  const unique = [...new Set(urls.filter(Boolean))];
  return Promise.all(unique.map(preloadOne)).then(() => undefined);
}

function preloadOne(url: string): Promise<void> {
  if (loaded.has(url)) return Promise.resolve();
  return new Promise((resolve) => {
    const img = new Image();
    img.onload = () => {
      loaded.add(url);
      resolve();
    };
    img.onerror = () => resolve();
    img.src = url;
  });
}
